import { type IntlShape } from 'react-intl-next';

import { getUserRecommendations } from '@atlaskit/smart-user-picker';

type ProductKeyType = 'confluence' | 'jira';

type GetAssigneesProps = {
	query: string;
	userId: string;
	cloudId: string;
	productKey: ProductKeyType;
	maxNumberOfResults: number;
	intl: IntlShape;
};

export const getAssignees: ({ query, userId, cloudId, productKey, maxNumberOfResults, intl, }: GetAssigneesProps) => Promise<import("@atlaskit/user-picker").OptionData[]> = ({
	query,
	userId,
	cloudId,
	productKey,
	maxNumberOfResults,
	intl,
}: GetAssigneesProps) => {
	const requestParams = {
		context: {
			contextType: 'assignee',
			principalId: userId,
			productAttributes: {
				isEntitledConfluenceExternalCollaborator: true,
			},
			productKey,
			siteId: cloudId,
		},
		includeGroups: false,
		includeTeams: false,
		includeUsers: true,
		maxNumberOfResults,
		performSearchQueryOnly: false,
		query,
	};

	return getUserRecommendations(requestParams, intl);
};
